import { createBrowserOnlyLazyComponent } from '@dbh/react-lazy';

var index = createBrowserOnlyLazyComponent(()=>import('./component-7900da4b.js'/* webpackChunkName: "dbh.loyalty-summary-banner" */));

export { index as default };
